import VehicleReportSettingsTab from './vehicle-report-settings';

export default VehicleReportSettingsTab;
